<template>
  <v-combobox
    id="edit-event-speakers-select"
    :label="$t('EVENTFORM.form.speakers')"
    multiple
    clearable
    outlined
    small-chips
    item-text="name"
    return-object
    :items="speakerUsers"
    v-model="speaks"
    v-on:input="$emit('input', speaks)"
  ></v-combobox>
</template>

<script>
export default {
  props: ["speakers"],
  data() {
    return {
      speaks: this.speakers,
    };
  },
  computed: {
    users() {
      return this.$store.getters.speakers || [];
    },
    speakerUsers() {
      return this.users.length
        ? this.users.map((user) => ({
            name: user.name,
            email: user.email,
            image: user.image || '',
            id: user.id,
            bio: user.bio
          }))
        : [];
    },
  },
  methods: {
    // required(value) {
    //   if (value instanceof Array && value.length == 0) {
    //     return this.$t('EVENTFORM.form_validation.speakers');
    //   }
    //   return !!value || this.$t('EVENTFORM.form_validation.speakers');
    // },
  },
  async created() {
    this.$store.dispatch("getSpeakers");
  },
};
</script>